import React from 'react';
import _ from 'lodash'
import {fromJS, Map} from 'immutable';
import {ContractsStore} from '../../stores';
import {Button} from 'react-bootstrap';
import {search} from '../../components/TableSearch/TableSearch';
import {Action, CellFormat, Icon, ListActions, PermissionRequired, TableSearch} from '../../components';
import {ContractsAction, ModalsAction} from '../../actions';
import {Activities} from '../../constants';
import Griddle from "griddle-react";
import formatter from "../../utils/formatter";

export default React.createClass({
  handleEditContractClick(props) {
    ModalsAction.showContractAirportForm(this.props.contractAirportFormModalId, props.rowData)
  },
  handleDeleteContractClick(props) {
    ModalsAction.show(this.props.contractAirportDeleteDialogId, {
      contractAirport: props.rowData,
      message:         "Are you sure you want to delete this airport (" + props.rowData.airportIcao + ") from the contract ?"
    })
  },
  getDetailsColumn() {
    return ["airportIcao", "plattAsText", "deliveryBy", "payment"/*, "hasPreNotification"*/, "price", "effectiveDate", "validUntil", "id"];
  },
  getDetailsColumnMetadata() {
    return [{
      columnName:      'airportIcao',
      displayName:     'Airport',
      customComponent: props => {
        const airportEntry = this.props.airports.get(String(props.rowData.airportIcao));
        if (!airportEntry) return (<p>{props.rowData.airportIcao}</p>);
        let airport = airportEntry.toJS();
        return (<p>{[airport.icao, airport.name].join(' - ')}</p>)
      },
      searchInput:     'text'
    }, {
      columnName:      'plattAsText',
      displayName:     'Platt',
      customComponent: props => {
        const plattEntry = this.props.platts.get(String(props.rowData.plattId));
        if (!plattEntry) return (<p>{props.rowData.plattId || ''}</p>);
        let platt = plattEntry.toJS();
        return (<p>{[platt.code, platt.name].join(' - ')}</p>)
      },
      searchInput:     'text'
    }, {
      columnName:  'deliveryBy',
      displayName: 'Delivery By'
    }, {
      columnName:  'payment',
      displayName: 'Payment'
    }, /*{
      columnName:      'hasPreNotification',
      displayName:     'Has PreNotification Required ?',
      customComponent: props => {
        return (<p>{props.rowData.hasPreNotification ? 'Yes' : 'No'}</p>)
      }
    },*/ {
      columnName:      'price',
      displayName:     'Price',
      customComponent: props => {
        let indices = fromJS(_.map(props.rowData.Values, (valueId, key) => {
          return this.props.values.get(String(valueId));
        }));

        if (indices && indices.toArray() && indices.toArray().length > 0) {
          let items = [];
          _.map(indices.toArray(), (indice, key) => {
            items.push(
              <div key={key}>
                <span>{indice ? indice.get('value') + ' ' + indice.get('currencyCode') + '/' + indice.get('volumeUnitCode') : ''}</span>
              </div>)
          });
          return (
            <div>
              {items}
            </div>
          )
        } else {
          return (<p></p>)
        }
      }
    }, {
      columnName:      'effectiveDate',
      displayName:     'Effective Date',
      customComponent: props => {
        let indices = fromJS(_.map(props.rowData.Values, (valueId, key) => {
          return this.props.values.get(String(valueId));
        }));

        if (indices && indices.toArray() && indices.toArray().length > 0) {
          let items = [];
          _.map(indices.toArray(), (indice, key) => {
            items.push(
              <div key={key}>
                <span>{indice ? formatter.format.date(indice.get('effectiveDate')) : ''}</span>
              </div>)
          });
          return (
            <div>
              {items}
            </div>
          )
        } else {
          return (<p></p>)
        }
      }
    }, {
      columnName:      'validUntil',
      displayName:     'Valid Until',
      customComponent: props => {
        let indices = fromJS(_.map(props.rowData.Values, (valueId, key) => {
          return this.props.values.get(String(valueId));
        }));

        if (indices && indices.toArray() && indices.toArray().length > 0) {
          let items = [];
          _.map(indices.toArray(), (indice, key) => {
            items.push(
              <div key={key}>
                <span>{indice && indice.get('validUntil') ? formatter.format.date(indice.get('validUntil')) : 'UFN'}</span>
              </div>)
          });
          return (
            <div>
              {items}
            </div>
          )
        } else {
          return (<p></p>)
        }
      }
    }, {      
      columnName:      'createdAt',
      displayName:     'Created At',
      customComponent: props => <CellFormat.ISODate value={props.rowData.createdAt}/>
    }, {
      columnName:      'updatedAt',
      displayName:     'Updated At',
      customComponent: props => <CellFormat.ISODate value={props.rowData.updatedAt}/>
    }, {      
      columnName:      "id",
      displayName:     "",
      cssClassName:    "actionsColumn",
      customComponent: props => {
        return (<ListActions>
          <PermissionRequired requiredRoles={Activities.WRITE_CONTRACTS} user={this.props.user}>
            <Action icon="edit" onClick={this.handleEditContractClick.bind(null, props)}/>
            <Action icon="remove" onClick={this.handleDeleteContractClick.bind(null, props)}/>
          </PermissionRequired>
        </ListActions>)
      }
    }];
  },

  propTypes: {
    platts:           React.PropTypes.object,
    airports:         React.PropTypes.object,
    contractAirports: React.PropTypes.object,
    values:           React.PropTypes.object,
    searchParams:     React.PropTypes.object,
  },

  getDefaultProps() {
    return {
      platts:           Map(),
      airports:         Map(),
      contractAirports: Map(),
      values:           Map(),
      searchParams:     Map()
    }
  },

  getInitialState() {
    return {
      contractAirports: this.enrichContractAirports(
        this.props.contractAirports, 
        this.props.platts,
        this.props.airports
      )
    }
  },

  /**
   * Enrich contract airports with searchable text fields  
   * @param {Map} contractAirports - Immutable Map of contract airports
   * @param {Map} platts - Immutable Map of platts
   * @param {Map} airports - Immutable Map of airports
   * @returns {Map} Enriched contract airports
   */
  enrichContractAirports(contractAirports, platts, airports) {
    const enriched = contractAirports.toJS();
    Object.keys(enriched).forEach(key => {
      const ca = enriched[key];
      
      // Add plattAsText for search
      if (ca.plattId && platts.has(String(ca.plattId))) {
        const platt = platts.get(String(ca.plattId)).toJS();
        ca.plattAsText = [platt.code, platt.name].join(' ');
      } else {
        ca.plattAsText = '';
      }
      
      // Add airportAsText for search (in addition to airportIcao)
      if (ca.airportIcao && airports.has(String(ca.airportIcao))) {
        const airport = airports.get(String(ca.airportIcao)).toJS();
        ca.airportAsText = [airport.icao, airport.name].join(' ');
      } else {
        ca.airportAsText = ca.airportIcao || '';
      }
    });
    return fromJS(enriched);
  },

  componentWillReceiveProps(nextProps) {
    const enrichedAirports = this.enrichContractAirports(
      nextProps.contractAirports, 
      nextProps.platts,
      nextProps.airports
    );
    if (nextProps.searchParams.size > 0) {
      let filteredContractAirports = search(
        enrichedAirports.toJS(),
        nextProps.searchParams.toJS()
      );
      this.setState({ contractAirports: fromJS(filteredContractAirports) });
    } else {
      this.setState({ contractAirports: enrichedAirports });
    }
  },

  componentWillUnmount() {
    ContractsStore.setState({ search: Map() });
  },

  render() {
    let {contract, platts, airports, values, contractAirports, user, onDelete, onEdit} = this.props;
    return (
      <div>
        <TableSearch
          user={this.props.user}
          requiredRoles={Activities.WRITE_FBOS}
          columnMetadata={this.getDetailsColumnMetadata()}
          onSearch={this.handleSearch}
          isNewButton={true}
          newButtonText="Add airport"
          onNew={this.props.onNew}/>

        <Griddle
          results={Object.values(this.state.contractAirports.toJS())}
          tableClassName="table"
          showSettings={true}
          resultsPerPage={20}
          columnMetadata={this.getDetailsColumnMetadata()}
          columns={this.getDetailsColumn()}/>
      </div>
    )
  },

  getImportButton() {
    return (
      <PermissionRequired requiredRoles={Activities.IMPORT_CONTRACTS} user={this.props.user}>
        <Button bsStyle="info" onClick={this.props.onImport}>
          <Icon fa="upload"/>
        </Button>
      </PermissionRequired>)
  },

  getColumnMetadata() {
    return [{
      columnName:   "airportIcao",
      displayName:  "ICAO",
      cssClassName: "",
      searchInput:  'text'
    }, {
      columnName:   "import",
      displayName:  "",
      cssClassName: "text-center col-xs-1",
      searchInput:  'component',
      component:    this.getImportButton(),
      user:         this.props.user
    }, {
      columnName:   "new",
      displayName:  "",
      cssClassName: "actionsColumn",
      searchInput:  'actions',
      user:         this.props.user
    }]
  },

  handleSearch(e) {
    let {name, value} = e.target;
    ContractsAction.search(name, value);
  }
});
